import React from "react";
import { Grid } from "@mui/material";
import FormField from "layouts/pages/account/components/FormField";
import SettingsCard from "./SettingsCard";

const SEOSection = ({ inputData, autoSaveField, gridProps = {} }) => {
  const handleBlurSave = (e) => {
    if (autoSaveField) autoSaveField(e.target.name, e.target.value);
  };

  return (
    <SettingsCard
      title="SEO"
      subtitle="Optimize your page for search engines"
      gridProps={gridProps}
    >
      <Grid container spacing={2.5}>
        <Grid item xs={12}>
          <FormField
            defaultValue={
              inputData?.home_m_title ||
              "Support Local - Discover & Support Small Businesses in Your Community"
            }
            label="Home Meta Title"
            name="home_m_title"
            onBlur={handleBlurSave}
          />
        </Grid>
        <Grid item xs={12}>
          <FormField
            defaultValue={
              inputData?.home_m_description ||
              "Support Local is your go-to directory for finding trusted small businesses near you. Explore shops, services, restaurants, and more — all in one place."
            }
            label="Home Meta Description"
            name="home_m_description"
            onBlur={handleBlurSave}
          />
        </Grid>
      </Grid>
    </SettingsCard>
  );
};

export default SEOSection;
